import CustomModalHeader from 'components/Custom/CustomModalHeader'
import { FormGroup, Modal, ModalBody } from 'reactstrap'
import Select from '../Select'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { fetchLocations } from 'store/Group/actions'
import { setSelectedStatus } from 'store/Forms/actions'
import { setSelectedLocation } from 'store/Forms/actions'
import { DateRangePicker, DayPickerRangeController } from 'react-dates'
import moment from 'moment'
import { setSelectedStartDate } from 'store/Forms/actions'
import { setSelectedEndDate } from 'store/Forms/actions'

const statuses = [
  { name: 'Not Started', value: 1 },
  { name: 'In Progress', value: 2 },
  { name: 'Done', value: 3 },
]

function FiltersModal({ showFiltersModal, setShowFiltersModal }) {
  const dispatch = useDispatch()

  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [focusedInput, setFocusedInput] = useState('startDate')

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const { locations } = useSelector((store) => store.groups)

  const {
    selectedLocation,
    selectedStatus,
    selectedStartDate,
    selectedEndDate,
  } = useSelector((store) => store.form)

  const [statusState, setStatusState] = useState(null)
  const [locationState, setLocationState] = useState(null)

  const language = languageRedux || {}

  useEffect(() => {
    dispatch(fetchLocations())
  }, [dispatch])

  useEffect(() => {
    if (selectedStatus) setStatusState(selectedStatus)
  }, [selectedStatus])

  useEffect(() => {
    if (selectedLocation) setLocationState(selectedLocation)
  }, [selectedLocation])

  useEffect(() => {
    if (selectedStartDate && selectedEndDate) {
      setStartDate(selectedStartDate)
      setEndDate(selectedEndDate)
    }
  }, [selectedStartDate, selectedEndDate])

  return (
    <Modal
      toggle={() => setShowFiltersModal(false)}
      isOpen={showFiltersModal}
      centered
      size='lg'
    >
      <CustomModalHeader
        title={'Filters'}
        toggle={() => setShowFiltersModal(false)}
      />
      <ModalBody>
        <div className='d-flex align-items-center'>
          <FormGroup className='w-100'>
            <label className='form-control-label' htmlFor='input-last-name'>
              Status
            </label>
            <Select
              options={statuses}
              selectedOptions={statusState}
              onChange={(option) => setStatusState(option)}
              multi={false}
              language={language}
              placeholder={'Select Status'}
            />
          </FormGroup>
          <FormGroup className='w-100 ml-5'>
            <label className='form-control-label' htmlFor='input-last-name'>
              Locations
            </label>
            <Select
              options={locations}
              selectedOptions={locationState}
              onChange={(option) => setLocationState(option)}
              multi={false}
              language={languageRedux}
              placeholder={'Select Location'}
            />
          </FormGroup>
        </div>
        <label className='form-control-label' htmlFor='input-last-name'>
          Date
        </label>
        <DayPickerRangeController
          startDate={startDate}
          endDate={endDate}
          onDatesChange={({ startDate, endDate }) => {
            setStartDate(startDate)
            setEndDate(endDate)
          }}
          focusedInput={focusedInput}
          onFocusChange={(focusedInput) =>
            setFocusedInput(focusedInput || 'startDate')
          }
          initialVisibleMonth={() => moment()}
          hideKeyboardShortcutsPanel={true}
        />
        <div className='d-flex align-items-center mt-5'>
          <button
            className='btn btn-danger'
            disabled={!statusState && !locationState && !startDate}
            onClick={() => {
              setStatusState(null)
              setLocationState(null)
              setStartDate(null)
              setEndDate(null)
              dispatch(setSelectedLocation(null))
              dispatch(setSelectedStatus(null))
              dispatch(setSelectedStartDate(null))
              dispatch(setSelectedEndDate(null))
            }}
          >
            Clear Filters
          </button>
          <button
            className='btn btn-info'
            onClick={() => {
              dispatch(setSelectedLocation(locationState))
              dispatch(setSelectedStatus(statusState))
              dispatch(setSelectedStartDate(startDate))
              dispatch(setSelectedEndDate(endDate))
              setShowFiltersModal(false)
            }}
          >
            Apply Filters
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default FiltersModal
